var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_STAFF = (storeId) => `api/store/${storeId}/staff`;
const GET_ASSIGNABLE_STAFF = (storeId) => `api/store/${storeId}/assignable-staffs`;
export const getStoreStaff = function (storeId, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_STAFF(storeId)}?${queryParams}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getStoreStaff:', error);
            throw error;
        }
    });
};
export const getStoreAssignableStaffs = function (storeId, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const normalizedQueryParams = typeof queryParams === "string"
                ? queryParams
                : generateQueryParamsStr([
                    "appendAdmin",
                    "storeIds",
                ], queryParams || {});
            const suffix = normalizedQueryParams ? `?${normalizedQueryParams}` : "";
            const response = yield this.axiosInstance.get(`${GET_ASSIGNABLE_STAFF(storeId)}${suffix}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getStoreAssignableStaffs:', error);
            throw error;
        }
    });
};
export const getStoreStaffById = function (storeId, staffId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_STAFF(storeId)}/${staffId}`, config);
        }
        catch (error) {
            console.error('Error fetching getStoreStaffById:', error);
            throw error;
        }
    });
};
